
// Think I need to keep operations on stores seperate?

import { pals } from "./stores";
import { get } from 'svelte/store';


export function getPalIndex(key) {

    let $pals = get(pals)

    let index;
    for (let i = 0; i < $pals.length; i++) {
        if ($pals[i].key == key) {
            index = i;
            i = $pals.length;
        }
    }
    return index
}

export function updatePal(key, update_data) {
    // Update the given key with new data
    // e.g. updatePal(key, {last_contact: "2022-12-1"})

    const index = getPalIndex(key)
    let $pals = get(pals)

    if (typeof index != "undefined") {
        var updated = $pals[index]
        for (var key in update_data) {
            updated[key] = update_data[key]
        }
        return [index, updated]
    }
    return []
}
